import React, { useEffect, useState } from "react";
import { getLastEmission } from "@store/action/planning/EmissionAction";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import FollowUs from "../FollowUs";

const Filter = ({ store, t, setCurrentPage, dispatch, path }) => {
  const lang = localStorage.getItem("lang") || "en";
  const lang1 = lang.substring(1, lang.length - 1) || "en";
  const [search, setSearch] = useState("");
  const history = useHistory();
  const { handleSubmit } = useForm();
  const onSubmit = () => {
    setCurrentPage(1);
    history.push(`/${path}?search=${search}`);
  };
  useEffect(() => {
    dispatch(getLastEmission());
  }, []);

  return (
    <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12 filterBlog">
      <div className="sidebar_widget">
        <h4>{t("search")}</h4>
        <form
          className="search_form"
          role="search"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="form-group">
            <input
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              className="form-control"
              placeholder={t("search")}
            />
            <button>
              <i className="fa fa-search" />
            </button>
          </div>
        </form>
      </div>
      <div className="sidebar_widget">
        <div className="wrapper_second_blog wrapper_second_blog_2">
          <h4>{t("Recent post")}</h4>
          {store.Last?.map((item, i) => {
            return (
              <div className="blog_wrapper1" key={i}>
                <div className="blog_image">
                  <Link to={`/emission/${item.id}`}>
                    <img
                      height="60px"
                      className="img-responsive"
                      src={item.picture}
                      alt="topic"
                    />
                  </Link>
                </div>
                <div className="sv_blog_text">
                  <h5 className="text-truncate">
                    <Link to={`/emission/${item.id}`}>{item.name}</Link>
                  </h5>
                  <div className="blog_date blog_date_blog">
                    <i className="fa fa-calendar-o me-1" aria-hidden="true" />
                    {new Date(item.created_at).toLocaleString(`${lang1}-US`, {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <FollowUs />
    </div>
  );
};

export default Filter;
